module.exports = __webpack_public_path__ + "static/media/host-award-banner.a5bf1c3f.jpg";